<div class="container-fluid">

  <!-- Cabecera -->
  <div class="page-header mb-3">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="mb-0">Consulta de usuarios</h5>
        <p class="text-muted small mb-0">{{ totalCount }} usuario(s) encontrado(s)</p>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" (click)="openNewUserModal(newUserModal)">
          <i class="fa fa-plus me-1"></i> Nuevo usuario
        </button>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="card shadow-sm border-0 mb-4">
    <div class="card-body">
      <div class="row g-3 align-items-end">

        <!-- Buscador -->
        <div class="col-md-5">
          <label class="form-label small text-muted mb-1">Buscar</label>
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="fa fa-search text-muted"></i>
            </span>
            <input
              type="text"
              class="form-control border-start-0"
              placeholder="Nombre, correo o teléfono..."
              [(ngModel)]="search"
              (keyup.enter)="onSearch()"
            />
          </div>
        </div>

        <!-- Filtro perfil -->
        <div class="col-md-3">
          <label class="form-label small text-muted mb-1">Perfil</label>
          <select class="form-select" [(ngModel)]="roleFilter" (change)="onFilterChange()">
            <option *ngFor="let opt of roleOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <!-- Filtro estado -->
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Estado</label>
          <select class="form-select" [(ngModel)]="activeFilter" (change)="onFilterChange()">
            <option *ngFor="let opt of activeOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <!-- Botón buscar -->
        <div class="col-md-2">
          <button class="btn btn-primary w-100" (click)="onSearch()">
            <i class="fa fa-search me-1"></i> Buscar
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- Tabla -->
  <div class="card shadow-sm border-0">
    <div class="card-body p-0">

      <!-- Spinner -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <!-- Sin resultados -->
      <div *ngIf="!loading && users.length === 0" class="text-center py-5">
        <i class="fa fa-users fa-2x text-muted mb-3 d-block"></i>
        <p class="text-muted mb-0">No se encontraron usuarios con los filtros aplicados.</p>
      </div>

      <!-- Tabla de resultados -->
      <div *ngIf="!loading && users.length > 0" class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th class="ps-3">Nombre</th>
              <th>Correo electrónico</th>
              <th>Teléfono</th>
              <th>Perfil</th>
              <th class="text-center">Estado</th>
              <th>Fecha alta</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users">
              <td class="ps-3">
                <span class="fw-semibold">{{ user.displayName || '—' }}</span>
              </td>
              <td>
                <span class="text-muted">{{ user.email }}</span>
              </td>
              <td>{{ user.phoneNumber || '—' }}</td>
              <td>
                <span [ngClass]="roleBadgeClass(user.roles)">
                  {{ roleLabel(user.roles) }}
                </span>
              </td>
              <td class="text-center">
                <span *ngIf="user.active" class="badge badge-success">Activa</span>
                <span *ngIf="!user.active" class="badge badge-light text-muted">Inactiva</span>
              </td>
              <td class="text-muted small">{{ user.created_at | date:'dd/MM/yyyy' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginación -->
    <div *ngIf="!loading && totalPages > 1" class="card-footer d-flex justify-content-between align-items-center">
      <p class="text-muted small mb-0">
        Página {{ currentPage + 1 }} de {{ totalPages }} — {{ totalCount }} registros
      </p>
      <div class="d-flex gap-2">
        <button
          class="btn btn-sm btn-outline-secondary"
          (click)="previousPage()"
          [disabled]="currentPage === 0"
        >
          <i class="fa fa-chevron-left"></i>
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="nextPage()"
          [disabled]="currentPage >= totalPages - 1"
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

</div>

<!-- Modal: Nuevo usuario -->
<ng-template #newUserModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Nuevo usuario</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">

      <div class="row g-3">
        <!-- Nombre -->
        <div class="col-md-6">
          <label class="form-label">Nombre(s) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [class.is-invalid]="f['firstName'].touched && f['firstName'].invalid"
            formControlName="firstName"
            placeholder="Nombre(s)"
          />
          <div class="invalid-feedback" *ngIf="f['firstName'].touched && f['firstName'].hasError('required')">
            Campo obligatorio
          </div>
          <div class="invalid-feedback" *ngIf="f['firstName'].touched && f['firstName'].hasError('minlength')">
            Mínimo 2 caracteres
          </div>
        </div>

        <!-- Apellido -->
        <div class="col-md-6">
          <label class="form-label">Apellido(s) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [class.is-invalid]="f['lastName'].touched && f['lastName'].invalid"
            formControlName="lastName"
            placeholder="Apellido(s)"
          />
          <div class="invalid-feedback" *ngIf="f['lastName'].touched && f['lastName'].hasError('required')">
            Campo obligatorio
          </div>
        </div>

        <!-- Correo -->
        <div class="col-12">
          <label class="form-label">Correo electrónico <span class="text-danger">*</span></label>
          <input
            type="email"
            class="form-control"
            [class.is-invalid]="f['email'].touched && f['email'].invalid"
            formControlName="email"
            placeholder="correo@ejemplo.com"
          />
          <div class="invalid-feedback" *ngIf="f['email'].touched && f['email'].hasError('required')">
            Campo obligatorio
          </div>
          <div class="invalid-feedback" *ngIf="f['email'].touched && f['email'].hasError('email')">
            Ingresa un correo válido
          </div>
        </div>

        <!-- Perfil -->
        <div class="col-12">
          <label class="form-label">Perfil <span class="text-danger">*</span></label>
          <select
            class="form-select"
            [class.is-invalid]="f['roles'].touched && f['roles'].invalid"
            formControlName="roles"
          >
            <option *ngFor="let opt of roleCreateOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="invalid-feedback">Selecciona un perfil</div>
        </div>
      </div>

      <p class="text-muted small mt-3 mb-0">
        <i class="fa fa-info-circle me-1"></i>
        Se enviará un correo al usuario para que active su cuenta y establezca su contraseña.
      </p>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="closeModal()" [disabled]="isSubmitting">
        Cancelar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        <span *ngIf="isSubmitting">
          <i class="fa fa-spinner fa-spin me-1"></i> Creando...
        </span>
        <span *ngIf="!isSubmitting">
          <i class="fa fa-paper-plane me-1"></i> Crear y enviar correo
        </span>
      </button>
    </div>
  </form>
</ng-template>
